
import { FETCH_CUSTOMERS,SEND_EMAIL_CUSTOMERS, FETCH_VERIFY_EMAIL, DELETE_CUSTOMERS, FETCH_ZIPCODES, CREATE_ZIPCODES, UPDATE_ZIPCODES, DELETE_ZIPCODES, FETCH_ABANDONED_CARTS, SEND_MESSAGE_TO_ABANDON_CUSTOMERS, SEND_MESSAGE_TO_ABANDON_CUSTOMERS_COUNT,GET_ABANDON_CART_CUSTOMERS_VIA_MEDICAL_RECORD,
  UPDATE_ABANDONED_CART_LEAD_INFO,FETCH_LOYAL_CUSTOMERS, FETCH_CUSTOM_TIME_ABANDONEDCART } from '../actions';
const initialState = {
  customerList: [],
  loading: false,
  customerListError:null,
  emailList:[],
  emailSendError:{},
  emailListError:{},
  deleteCustomer: {},
  zipcodeLinkList: [],
  zipcodeLinkListError: {},
  createdZipcode: {},
  updatedZipcode: {},
  deletedZipCode:{},
  abandonedCartsList: [], 
  messageToAbandonCustomers: [],
  messageToAbandonCustomersCount: [],
  loyalCustomersData:[],
};

function customerReducer(state = initialState, action) {
  let customerList,email,emailList, deleteCustomer, zipcodeLinkList,createdZipcode,updatedZipcode,deletedZipCode,abandonedCartsList, messageToAbandonCustomers, messageToAbandonCustomersCount,
  abandonCustomers,updatedAbandonedCartLead,loyalCustomersData, customTimeAbandonedCart;

  switch (action.type) {
    case `${FETCH_CUSTOMERS}_PENDING`:

      return { ...state, loading: true };
    
    case `${DELETE_CUSTOMERS}_PENDING`:
      return { ...state, loading: true };

    case `${FETCH_CUSTOMERS}_FULFILLED`:
      customerList = action.payload.data;
      return { ...state, loading: false, customerList };

    case `${FETCH_CUSTOMERS}_REJECTED`:
      return { ...state,loading: false, customerListError: `${action.payload.message}`, state: initialState };
    
    case `${SEND_EMAIL_CUSTOMERS}_FULFILLED`:
      email = action.payload.data;
      return { ...state, loading: false, email };
       
    case `${SEND_EMAIL_CUSTOMERS}_REJECTED`:     
      return { ...state,loading: false, emailSendError: `${action.payload.response.data.findpet}`, state: initialState };
          
    case `${FETCH_VERIFY_EMAIL}_FULFILLED`:
      emailList = action.payload.data;
      return { ...state, loading: false, emailList };
      
    case `${FETCH_VERIFY_EMAIL}_REJECTED`:
      return { ...state,loading: false, emailListError: `${action.payload.message}`, state: initialState };  
        
    case `${DELETE_CUSTOMERS}_FULFILLED`:
        deleteCustomer = action.payload.data;
        return { ...state, loading: false, deleteCustomer };

    case `${DELETE_CUSTOMERS}_REJECTED`:  
        return { ...state,loading: false, deleteCustomerError: action.payload.response.data, state: initialState }; 

    case `${FETCH_ZIPCODES}_FULFILLED`:
      zipcodeLinkList = action.payload.data;
      return { ...state, loading: false, zipcodeLinkList };
      
    case `${FETCH_ZIPCODES}_REJECTED`:
      return { ...state,loading: false, zipcodeLinkListError: `${action.payload.message}`, state: initialState };  
          
    case `${CREATE_ZIPCODES}_FULFILLED`:
      createdZipcode = action.payload.data;
      return { ...state, loading: false, createdZipcode };
          
    case `${CREATE_ZIPCODES}_REJECTED`:      
      return { ...state,loading: false, createZipcodeError: action.payload.response.data, state: initialState };  
             
    case `${UPDATE_ZIPCODES}_FULFILLED`:
      updatedZipcode = action.payload.data;
      return { ...state, loading: false, updatedZipcode };
          
    case `${UPDATE_ZIPCODES}_REJECTED`:   
      return { ...state,loading: false, updatedZipcodeError: action.payload.response.data, state: initialState }; 
      
    case `${DELETE_ZIPCODES}_FULFILLED`:
      deletedZipCode = action.payload.data;
      return {...state, loading:false, deletedZipCode };

    case `${DELETE_ZIPCODES}_REJECTED`:   
      return { ...state,loading: false, deletedZipCodeError: action.payload.response.data, state: initialState };
      
    case `${FETCH_ABANDONED_CARTS}_FULFILLED`:
      abandonedCartsList = action.payload.data;
        return { ...state, loading: false, abandonedCartsList };
        
    case `${FETCH_ABANDONED_CARTS}_REJECTED`:
        return { ...state,loading: false, abandonedCartsError: `${action.payload.message}`, state: initialState }; 

    case `${SEND_MESSAGE_TO_ABANDON_CUSTOMERS}_PENDING`:
      return { ...state, loading: true };

    case `${SEND_MESSAGE_TO_ABANDON_CUSTOMERS}_FULFILLED`:
      messageToAbandonCustomers = action.payload.data;
      return { ...state, loading: false, messageToAbandonCustomers };

    case `${SEND_MESSAGE_TO_ABANDON_CUSTOMERS}_REJECTED`:
      return { ...state,loading: false, messageToAbandonCustomersError: `${action.payload.message}`, state: initialState };

    case `${SEND_MESSAGE_TO_ABANDON_CUSTOMERS_COUNT}_PENDING`:
      return { ...state, loading: true };

    case `${SEND_MESSAGE_TO_ABANDON_CUSTOMERS_COUNT}_FULFILLED`:
      messageToAbandonCustomersCount = action.payload.data;
      return { ...state, loading: false, messageToAbandonCustomersCount };

    case `${SEND_MESSAGE_TO_ABANDON_CUSTOMERS_COUNT}_REJECTED`:
      return { ...state,loading: false, messageToAbandonCustomersCountError: `${action.payload.message}`, state: initialState };  

    case `${GET_ABANDON_CART_CUSTOMERS_VIA_MEDICAL_RECORD}_PENDING`:
        return { ...state, loading: true };

    case `${GET_ABANDON_CART_CUSTOMERS_VIA_MEDICAL_RECORD}_FULFILLED`:
        abandonCustomers = action.payload.data;
        return { ...state, loading: false, abandonCustomers };        

    case `${GET_ABANDON_CART_CUSTOMERS_VIA_MEDICAL_RECORD}_REJECTED`:
      return { ...state,loading: false, abandonCustomersError: `${action.payload.message}`, state: initialState }; 

    case `${UPDATE_ABANDONED_CART_LEAD_INFO}_PENDING`:
      return { ...state, loading: true };
      
    case `${UPDATE_ABANDONED_CART_LEAD_INFO}_FULFILLED`:
        updatedAbandonedCartLead = action.payload.data;
        return { ...state, loading: false, updatedAbandonedCartLead };

    case `${UPDATE_ABANDONED_CART_LEAD_INFO}_REJECTED`:
        return { ...state,loading: false, updatedAbandonedCartLeadError: `${action.payload.message}`, state: initialState }; 
      
    case `${FETCH_LOYAL_CUSTOMERS}_FULFILLED`:
        loyalCustomersData = action.payload.data;
        return { ...state, loading: false, loyalCustomersData }; 
    
    case `${FETCH_LOYAL_CUSTOMERS}_REJECTED`:
          return { ...state,loading: false, loyalCustomersDataError: `${action.payload.message}`, state: initialState };  

    case `${FETCH_CUSTOM_TIME_ABANDONEDCART}_FULFILLED`:
        customTimeAbandonedCart = action.payload.data;
        return { ...state, loading: false, customTimeAbandonedCart }; 

    case `${FETCH_CUSTOM_TIME_ABANDONEDCART}_REJECTED`:
        return { ...state,loading: false, customTimeAbandonedCartError: `${action.payload.message}`, state: initialState };
    
    default:
      return state;
  }
}

export default customerReducer;
